import { PlatformData } from '../ModuleConfig';

export interface IosModuleConfigData extends PlatformData {
  '@type': 'type.googleapis.com/terra.v1.IosModuleConfigData';
  initClass: string;
  linkProcessorClass: string;
}

export const IosModuleConfigDataFields: (keyof IosModuleConfigData)[] = [
  'initClass',
  'linkProcessorClass',
];
